export const ACTIONS = {
  REFILL: {
    label: 'Пополнение',
    value: 'REFILL',
  },
  WITHDRAWAL: {
    label: 'Снятие',
    value: 'WITHDRAWAL',
  },
  TARIFF: {
    label: 'Покупка услуги',
    value: 'TARIFF',
  },
};
